<template>
    <div class="transaction">
        <div v-if="!isLoadingScreen">
            <div class="transaction__content" v-for="(item, key) in dataHistory" :key="key">
                <div class="col-first">
                    <p>
                        <b>{{ getTranslatedText('created at') }}:</b> {{ renderDate(item.created_at) }}
                    </p>
                    <p>
                        <b>{{ getTranslatedText('transaction id') }}:</b> {{ item.transaction_id }}
                    </p>
                    <p>
                        <b>{{ getTranslatedText('amount') }}:</b> {{ renderPrice(item.wager) }}
                    </p>
                </div>
                <div class="col-last">
                    <p>
                        <b>{{ getTranslatedText('type') }}:</b> {{ getTranslatedText(item.type) }}
                    </p>
                    <p>
                        <b>{{ getTranslatedText('status') }}:</b> {{ getStatus(item) }}
                    </p>
                    <div class="transaction__box-button">
                        <p
                            v-if="shouldShowCancelUi(item) && hasCancelCountdown(item)"
                            class="transaction__cancel-timer"
                        >
                            {{
                                getTranslatedText('history cancel timer', {
                                    time: formatCancelDeadlineCountdown(item),
                                })
                            }}
                        </p>
                        <ButtonCommon
                            v-if="shouldShowCancelUi(item)"
                            className="w100"
                            :isNoHover="true"
                            value="CANCEL TICKET"
                            nameFunction="on-click-modal"
                            :paramFunction="item"
                        />
                    </div>
                </div>
            </div>
        </div>
        <EmptyScreen v-if="!isLoadingScreen && dataHistory.length === 0" text="Empty result" />
        <LoadingScreen v-if="isLoadingScreen" />
        <div class="transaction__re-box-button">
            <ButtonCommon className="w100" :isNoHover="true" :isLoading="isLoadingButton" value="Refresh" nameFunction="on-refresh-history" />
        </div>
        <v-dialog v-model="dialog" content-class="modal-ticket">
            <v-card>
                <v-card-text>
                    {{ getTranslatedText('Are you sure you would like to cancel this Bet?') }}
                    <br />
                    {{ getTranslatedText('Identifiant de transaction:') }} {{ transactionId }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="modal-ticket__box-button">
                        <ButtonCommon
                            className="w100 close"
                            :isNoHover="true"
                            value="Close"
                            nameFunction="on-close-modal"
                        />
                        <ButtonCommon
                            className="w100 yes"
                            :isNoHover="true"
                            :isLoading="isLoadingButtonCancel"
                            value="confirm"
                            nameFunction="on-handle-cancel-ticket"
                        />
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import EmptyScreen from '@/components/common/empty/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'
import EventBus from '@/utils/EventBus'
import HistoryService from '@/services/history.service'
import BetslipsService from '@/services/betslip.service'
import { formatDateUTC00, formatPrice } from '@/utils/utils'
import ButtonCommon from '@/components/common/button/index.vue'
import { isArrayEmpty } from '@/utils/utils'
import { INSTANT_SLUG_GAME } from '@/constants/lotto'

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, EmptyScreen, LoadingScreen },
    props: {
        limit: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            isLoadingButton: false,
            isLoadingScreen: false,
            isLoadingButtonCancel: false,
            dataHistory: [],
            dialog: false,
            transactionId: null,
            betslipId: null,
            INSTANT_SLUG_GAME,
            cancelCountdownTick: Date.now(),
            _cancelCountdownTimer: null,
        }
    },
    mounted() {
        this.fetchHistory()
        this._cancelCountdownTimer = setInterval(() => {
            this.cancelCountdownTick = Date.now()
        }, 1000)
    },
    created() {
        EventBus.$on('on-click-modal', (item) => {
            this.dialog = true
            this.transactionId = item.transaction_id
            this.betslipId = item.betslip_id
        })
        EventBus.$on('on-close-modal', () => {
            this.dialog = false
        })
        EventBus.$on('on-handle-cancel-ticket', () => {
            this.handleCancelTicket()
        })
        EventBus.$on('on-refresh-history', () => {
            this.isLoadingButton = true
            this.fetchHistory()
        })
    },
    destroyed() {
        if (this._cancelCountdownTimer != null) {
            clearInterval(this._cancelCountdownTimer)
            this._cancelCountdownTimer = null
        }
        EventBus.$off('on-click-modal')
        EventBus.$off('on-close-modal')
        EventBus.$off('on-handle-cancel-ticket')
        EventBus.$off('on-refresh-history')
    },
    methods: {
        async fetchHistory() {
            this.isLoadingScreen = true
            try {
            console.log('fetchHistory')
                const resp = await HistoryService.getLastNBet(this.limit)
                if (resp.status === 200) {
                    this.dataHistory = resp.data
                    this.isLoadingScreen = false
                    this.isLoadingButton = false
                } else {
                  this.isLoadingScreen = false
                  this.isLoadingButton = false
                  const param = {
                    text: resp.message,
                    type: 'error',
                  }
                  EventBus.$emit('show-notications', param)
                }
            } catch (error) {
                console.log(error)
                this.isLoadingScreen = false
                this.isLoadingButton = false
            }
        },

        async handleCancelTicket() {
            this.isLoadingButtonCancel = true
            try {
                const resp = await BetslipsService.cancelBetslip(this.betslipId)
                if (resp.status === 200) {
                    this.fetchHistory()
                    this.dialog = false
                    this.isLoadingButtonCancel = false
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              message += element.message
                          })
                        : (message = resp.message)
                  const param = {
                        text: message ? message : 'cancel successfully',
                        type: 'success',
                    }
                    EventBus.$emit('show-notications', param)
                } else {
                    this.dialog = false
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              message += element.message
                          })
                        : (message = resp.message)
                    const param = {
                        text: message,
                        type: 'error',
                        className: 'up-first'
                    }
                    EventBus.$emit('show-notications', param)
                    this.isLoadingButtonCancel = false
                }
            } catch (error) {
                console.log(error)
                this.isLoadingButtonCancel = false
            }
        },

        isCancelButtonVisible(item) {
            return (
                !((item.not_allowed_to_cancel ?? false) || item.cancelled || parseInt(item.cancelled_count) > 0) &&
                item.type !== this.INSTANT_SLUG_GAME
            )
        },

        shouldShowCancelUi(item) {
            if (!this.isCancelButtonVisible(item)) {
                return false
            }
            if (this.hasCancelCountdown(item)) {
                return this.secondsUntilCancelDeadline(item) > 0
            }
            return true
        },

        cancelWindowExpiresAtMs(item) {
            const created = item.created_at
            const mins = Number(item.cancelable_mins_after_bet)
            if (created == null || !Number.isFinite(mins) || mins < 0) {
                return null
            }
            const t = new Date(created).getTime()
            if (Number.isNaN(t)) {
                return null
            }
            return t + mins * 60 * 1000
        },

        hasCancelCountdown(item) {
            return this.cancelWindowExpiresAtMs(item) != null
        },

        secondsUntilCancelDeadline(item) {
            const end = this.cancelWindowExpiresAtMs(item)
            if (end == null) {
                return null
            }
            return Math.max(0, Math.floor((end - this.cancelCountdownTick) / 1000))
        },

        formatDurationMmSs(totalSeconds) {
            const s = Math.max(0, totalSeconds)
            const h = Math.floor(s / 3600)
            const m = Math.floor((s % 3600) / 60)
            const sec = s % 60
            if (h > 0) {
                return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
            }
            return `${m}:${String(sec).padStart(2, '0')}`
        },

        formatCancelDeadlineCountdown(item) {
            const sec = this.secondsUntilCancelDeadline(item)
            if (sec === null) {
                return ''
            }
            return this.formatDurationMmSs(sec)
        },

        getStatus(item) {
            if (item.cancelled) {
                return this.getTranslatedText('cancelled')
            } else if (parseInt(item.cancelled_count) > 0) {
                return this.getTranslatedText('cancelling')
            }
            return this.getTranslatedText('OK')
        },

        renderDate(date) {
            const dateFormat = formatDateUTC00(date)

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`

            return valueDate
        },

        renderPrice(price) {
            return formatPrice(price)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/transaction/_index.scss';
</style>
